/**
 * Confirm helpers for coach skip sequence / skip exercise.
 * Uses window.confirm to match finalize (confirmFinalizeExercise).
 */

/**
 * Live UI reports currentSequence as 1-based, including during the
 * between-sequence gap (upcoming block is treated as current).
 */
export function getSkipSequenceConfirmInfo({
  sequences,
  currentSequence,
} = {}) {
  const list = Array.isArray(sequences) ? sequences : [];
  const total = list.length;
  const curNum = Number(currentSequence);
  const current =
    Number.isFinite(curNum) && curNum > 0 ? Math.floor(curNum) : 1;
  const isLast = total <= 0 || current >= total;
  return { current, total: Math.max(total, 1), isLast };
}

function translateOrFallback(t, key, fallback, vars) {
  if (typeof t !== "function") return fallback;
  const interpolated = t(key, vars);
  if (!interpolated || interpolated === key) return fallback;
  return interpolated;
}

/**
 * @returns {boolean} true if the coach confirmed skip sequence
 */
export function confirmSkipSequence({
  sequences,
  currentSequence,
  t,
} = {}) {
  const info = getSkipSequenceConfirmInfo({ sequences, currentSequence });
  const vars = { current: info.current, total: info.total };
  const message = info.isLast
    ? translateOrFallback(
        t,
        "confirmSkipSequenceLast",
        `Skip sequence ${info.current} of ${info.total} and go to the next exercise?`,
        vars
      )
    : translateOrFallback(
        t,
        "confirmSkipSequence",
        `Skip sequence ${info.current} of ${info.total} and start the next?`,
        vars
      );
  return typeof window.confirm === "function" ? window.confirm(message) : false;
}

/**
 * @returns {boolean} true if the coach confirmed cancel/skip of a scheduled exercise
 */
export function confirmSkipExercise({ hasNext = true, t } = {}) {
  const message = hasNext
    ? translateOrFallback(
        t,
        "confirmSkipExercise",
        "Cancel this exercise and go to the next?"
      )
    : translateOrFallback(
        t,
        "confirmSkipExerciseLast",
        "Cancel this exercise? If it is the last one, the session will wait for your next decision."
      );
  return typeof window.confirm === "function" ? window.confirm(message) : false;
}
